/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import LogosVersion2 from '../PersonaliseLessons/components/Logo2'
import CourseDropDown from './CourseDropDown'
import CourseSyllabus from './CourseSyllabus'
import Projects from './Projects'
import CertificateSection from './components/CertificateSection'
import LiveDoubtSolving from './components/LiveDoubtSolving'
import InterviewAndFeedback from './components/InterviewAndFeedback'
import PracticalProjects from './components/PracticalProjects'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import BenefitsOfCourse from './components/BenefitsOfCourse'
import CourseOutcomes from './components/CourseOutcomes'
import CourseProgress from './CourseProgress'
import { useDispatch, useSelector } from 'react-redux'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { fetchCourseModule, selectCourseModule, selectCourseModuleContent } from '../../redux/personaliseLessons/courseModuleSlice'
import BottomStickyBar from './components/BottomStickyBar'
import { fetchCourseProgress } from '../../redux/personaliseLessons/moduleProgressSlice'
import { selectScholarshipData, setCreatedAt } from '../../redux/personaliseLessons/scholarshipAppliedSlice'
import constants from '../PersonaliseLessons/utilities/constants'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import { Mixpanel } from '../../config/Mixpanel'
import { useNavigate, useParams } from 'react-router-dom'
import LearnTubeXIllustartion from '../PersonaliseLessons/components/LearnTubeXIllustartion'
import { fetchSubscriptionStatus, selectSubscriptionStatus } from '../../redux/personaliseLessons/subscriptionStatusSlice'
import SubscriptionStatusModal from './SubscriptionStatusModal'
import { fetchBottomIllustationStatus, selectBottomIllustationStatus } from '../../redux/personaliseLessons/bottomIllustration'
import CertificateDownload from './CertificateDownload'
import { resetLessonDetails } from '../../redux/personaliseLessons/lessonDetailsSlice'
import { checkTrialPeriod, selectTrialPeriod, setLastVisitedUrl } from '../../redux/personaliseLessons/nameSlice'
import { toast } from 'react-toastify'
import { checkUserInWhiteList } from '../../redux/personaliseLessons/whiteListSlice'
import { axiosNoAuth } from '../../redux/personaliseLessons/axiosInstance'

const CourseListPage = () => {

    const [isAtEnd, setIsAtEnd] = useState(false)
    const { course_slug } = useParams()
    const courseList = useSelector(selectCourseList)?.subject_names
    const courseModule = useSelector(selectCourseModule)
    const courseModuleContent = useSelector(selectCourseModuleContent)
    const createdAt = useSelector(selectScholarshipData)?.appliedAt
    const authentication = useSelector(selectAuthentication)
    const trialPeriod= useSelector(selectTrialPeriod)
    const uid = authentication?.uid
    const email = authentication?.email
    const subscriptionStatus = useSelector(selectSubscriptionStatus)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const courseProgress=courseModule?.course_progress
    const userRole = useSelector(store => store?.userSubscription)

    const [ certificateUrl, setCertificateUrl ] = useState('')
    const [ showDropDown, setShowDropDown ] = useState(false)
    console.log('subscription' , userRole)

    // Dummy function - course selection navigates to new URL, doesn't update local state
    const setCourseName = () => {}
    
    const dispatch = useDispatch()
    const sentinelRef1 = useRef(null)
    const scrollRef = useRef(null)
    const dropDownRef = useRef(null)
    const navigate = useNavigate()
    
    useEffect(() => {
       Mixpanel.track(constants.Mixpanel.COURSE_LIST_PAGE)
       dispatch(setLastVisitedUrl(`/login?email=${email}`))
      
       const fetchData = async () => {
            try{
                if (course_slug && email) {
                    await dispatch(checkTrialPeriod({ subject: course_slug, email })).unwrap()
                }
                const response = await dispatch(fetchSubscriptionStatus({ email: email }))
                if (response?.payload?.type === 'super' || response?.payload?.type === 'subscription'){
                    dispatch(fetchBottomIllustationStatus({ email: email }))
                }   
            }catch(err){
                console.log(err.message)
            }
       }
       fetchData()
       dispatch(resetLessonDetails())
        if (createdAt > 0){
            if (createdAt - Date.now() < 0) {
                dispatch(setCreatedAt(Date.now() + (36 * 60 * 60 * 1000)))
            }
        } else {
            dispatch(setCreatedAt(Date.now() + (36 * 60 * 60 * 1000)))
        }
        const handleClickOutside = (event) => {
            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setShowDropDown(false)
            }
        }

        document.addEventListener('click', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
        }  
    }, [])

    useEffect(() => {
        dispatch(checkUserInWhiteList({ email }))
    },[email])

    useEffect(() => {
        if (scrollRef.current){
            scrollRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [course_slug])

    useEffect(() => {
        if (courseProgress === 100 && course_slug) {
            const fetchCertificateData = async () => {
                try {
                    const response = await axiosNoAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:certificate/create/beta', {
                        certificate_type: 'personalized',
                        user_uuid: uid,
                        subject_name: course_slug
                    });
                    if (response.data?.result === 'failed'){
                        throw new Error('Could not create')
                    }
                    if (response.data?.data?.certificate_image_link?.length > 0){
                        setCertificateUrl(response.data?.data?.certificate_image_link)
                    }else{
                        const imageData = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/file/beta', {
                            params: {
                                certificate_type: 'personalized',
                                unique_certificate_id: response.data?.data?.unique_certificate_id,
                                file_type: 'image_png'
                            }
                        });
                        setCertificateUrl(imageData.data?.data)
                    }
                } catch (err) {
                    console.log(err.message)
                }
            }
            fetchCertificateData()
        }
    },[courseProgress, course_slug])

    useEffect(() => {
        if (course_slug) {
            const fetchData = async () => {
                try {
                    const courseProgressPromise = await dispatch(fetchCourseProgress({ uid: uid, subject_name: course_slug })).unwrap()
                    const courseModulePromise = await dispatch(fetchCourseModule({ uid: uid, subject_name: course_slug })).unwrap()
                    await Promise.allSettled([courseProgressPromise, courseModulePromise])
                }catch(error) {
                    console.log(error);
                    toast.error("Something went wrong! Please try again later.")
                    navigate(-1, { replace: true })
                    return
                }
            }
            fetchData()
        }
    }, [course_slug])
    
    const showBanner = useMemo(() => {
        if (userRole && (userRole?.role_type === 'max' || userRole?.role_type === 'x')){
            return false
        }else{
            return !!trialPeriod?.show_banner
        }
    }, [trialPeriod, userRole])

    const handleNavigation = () => {
        if (courseProgress === 0){
            navigate(`/personalise/${encodeURIComponent(course_slug)}/${courseModule?.course_data?.[0]?.module_slug}/${courseModule?.course_data?.[0]?.module_content?.[0]?.lesson_slug}`)
        } else {
            let moduleIndex = courseModule?.course_data?.findIndex((item) => item?.module_progress < 100)
            if (moduleIndex >= 0) {
                let lessonIndex = courseModule?.course_data?.[moduleIndex]?.module_content?.findIndex((item) => item?.lesson_status !== 'completed')
                navigate(`/personalise/${encodeURIComponent(course_slug)}/${courseModule?.course_data?.[moduleIndex]?.module_slug}/${courseModule?.course_data?.[moduleIndex]?.module_content?.[lessonIndex]?.lesson_slug}`)
            } else {
                toast.success('Course is completed successfully')
            }
        }
    }
    return (
        <div className='w-full max-w-[720px] mx-auto relative'>
            <div ref={scrollRef} className='absolute -top-[120px]'/>
            <div className='w-full text-white p-4'>
                <div className='flex w-full justify-between mb-4'>
                    <LogosVersion2/>
                </div>
                <BottomStickyBar
                    isAtEnd={isAtEnd}
                    courseName={course_slug}
                    handleNavigation={handleNavigation}
                />
                <div ref={dropDownRef} className='mt-2 text-white'>
                    <CourseDropDown
                        courseList={courseList}
                        courseName={course_slug}
                        setCourseName={setCourseName}
                        email={email}
                        showDropDown={showDropDown} 
                        setShowDropDown={setShowDropDown}
                    />
                </div>
                <div className='mt-5'>
                    <CourseProgress
                        courseModule={courseModule}
                    />
                </div>
                <div className='mt-7'>
                    <CourseSyllabus
                        courseModule={courseModule}
                        courseList={courseList}
                        courseName={course_slug}
                    />
                </div>
                {/* {courseModule?.course_projects?.length > 0 && <div className='mt-7'>
                    <Projects 
                        courseName={course_slug}
                        courseProjects={courseModule?.course_projects}
                        courseModule={courseModule}
                    />
                </div>} */}
                <div className='mt-7'>
                    <h2 className='text-2xl font-semibold mb-3'>Your Certificate</h2>
                    <CertificateDownload 
                        courseProgress={courseModule?.course_progress}
                        certificateUrl={certificateUrl}
                        handleNavigation={handleNavigation}
                    />
                </div>
                <div className='mt-7'>
                    <h3 className='text-2xl font-semibold'>Features Of This Course</h3>
                    <CertificateSection
                        courseModuleContent={courseModuleContent}
                    />
                    <LiveDoubtSolving/>
                    <InterviewAndFeedback/>
                    <PracticalProjects/>
                    <div className='mt-3 bg-[#2D4F71] p-3 rounded-xl'>
                        <div className='flex items-center justify-between'>
                            <div className='flex'>
                                <FontAwesomeIcon icon={faCircleCheck} className='text-[#55A47E] bg-white rounded-full text-xl mr-2'/>
                                <p className='font-medium'>Lifetime Access</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mt-7'>
                    <BenefitsOfCourse/>
                </div>
                {courseModule?.course_outcome?.length > 0 ? <div className='mt-7'>
                    <CourseOutcomes
                        outcomes={courseModule?.course_outcome}
                    />
                </div> : null}
                {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='mt-7'>
                    <LearnTubeXIllustartion
                        sentinelRef={sentinelRef1}
                        setIsAtEnd={setIsAtEnd}
                        authentication={authentication}
                    />
                </div> : <div className='h-[60px] w-full'></div>}
                <SubscriptionStatusModal
                    isOpen={showBanner}
                    authentication={authentication}
                    courseList={courseList}
                    courseName={course_slug}
                    setCourseName={setCourseName}
                    email={email}
                />
            </div>
        </div>
    )
}

export default CourseListPage
